// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.web.user.persona.dto.PropertyOwnershipVerificationState

export enum PropertyOwnershipVerificationState {
  APPROVED = 'APPROVED',
  COMPLETED = 'COMPLETED',
  CREATED = 'CREATED',
  DECLINED = 'DECLINED',
  EXPIRED = 'EXPIRED',
  FAILED = 'FAILED',
  NEEDS_REVIEW = 'NEEDS_REVIEW',
  NOT_APPLICABLE = 'NOT_APPLICABLE',
  NOT_STARTED = 'NOT_STARTED',
  PENDING = 'PENDING',
}

export const PropertyOwnershipVerificationState_values = [
  PropertyOwnershipVerificationState.APPROVED,
  PropertyOwnershipVerificationState.COMPLETED,
  PropertyOwnershipVerificationState.CREATED,
  PropertyOwnershipVerificationState.DECLINED,
  PropertyOwnershipVerificationState.EXPIRED,
  PropertyOwnershipVerificationState.FAILED,
  PropertyOwnershipVerificationState.NEEDS_REVIEW,
  PropertyOwnershipVerificationState.NOT_APPLICABLE,
  PropertyOwnershipVerificationState.NOT_STARTED,
  PropertyOwnershipVerificationState.PENDING,
] as const;
